/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserPointsHistoryPageRespVo } from './GetUserPointsHistoryPageRespVo';
import {
    GetUserPointsHistoryPageRespVoFromJSON,
    GetUserPointsHistoryPageRespVoFromJSONTyped,
    GetUserPointsHistoryPageRespVoToJSON,
    GetUserPointsHistoryPageRespVoToJSONTyped,
} from './GetUserPointsHistoryPageRespVo';

/**
 * 
 * @export
 * @interface PageDataGetUserPointsHistoryPageRespVo
 */
export interface PageDataGetUserPointsHistoryPageRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataGetUserPointsHistoryPageRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataGetUserPointsHistoryPageRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataGetUserPointsHistoryPageRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<GetUserPointsHistoryPageRespVo>}
     * @memberof PageDataGetUserPointsHistoryPageRespVo
     */
    records?: Array<GetUserPointsHistoryPageRespVo>;
}

/**
 * Check if a given object implements the PageDataGetUserPointsHistoryPageRespVo interface.
 */
export function instanceOfPageDataGetUserPointsHistoryPageRespVo(value: object): value is PageDataGetUserPointsHistoryPageRespVo {
    return true;
}

export function PageDataGetUserPointsHistoryPageRespVoFromJSON(json: any): PageDataGetUserPointsHistoryPageRespVo {
    return PageDataGetUserPointsHistoryPageRespVoFromJSONTyped(json, false);
}

export function PageDataGetUserPointsHistoryPageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataGetUserPointsHistoryPageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(GetUserPointsHistoryPageRespVoFromJSON)),
    };
}

export function PageDataGetUserPointsHistoryPageRespVoToJSON(json: any): PageDataGetUserPointsHistoryPageRespVo {
    return PageDataGetUserPointsHistoryPageRespVoToJSONTyped(json, false);
}

export function PageDataGetUserPointsHistoryPageRespVoToJSONTyped(value?: PageDataGetUserPointsHistoryPageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(GetUserPointsHistoryPageRespVoToJSON)),
    };
}

